export default "__VITE_ASSET__CF4PCnwu__"